import React, {useEffect, useState} from 'react';
import {requestGetEmployerList} from "@app/services/EmployerService";
import {DEFAULT_PAGE_SIZE} from "@app/constants/Common";
import EmployerListTable, {EmployerListTableMode} from "@pages/employer/list/EmployerListTable";

const EmployerList = (props) => {
    const [employers, setEmployers] = useState([]);
    const [allEmployerIds, setAllEmployerIds] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const { hideSearchForm, showBtnSelect } = props;

    const searchEmployerList = (condition) => {
        setIsLoading(true)

        // let params = {page: page, size: DEFAULT_PAGE_SIZE}
        let params = {search_conditions: condition}
        requestGetEmployerList(params). then((res) => {
            const items = res.content.employers.map((item, index) => {
                item.no = (res.content.page - 1) * DEFAULT_PAGE_SIZE + index + 1
                return item
            });
            setEmployers(items);
            setAllEmployerIds(res.content.all_employer_ids);
            setTotalCount(res.content.totalCount)
            // setCurrentPage(res.content.page)
            // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            setEmployers([]);
            setAllEmployerIds([]);
            setTotalCount(0)
            // setNumberPages(0);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        searchEmployerList()
    }, []);

    return (
        <div className='container-fluid'>
            <div className='card card-primary'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>{'Danh sách Employer'}</h3>
                    {/*<div className='card-tools'>*/}
                    {/*    <a href='#'*/}
                    {/*            className=''*/}
                    {/*            onClick={() => {*/}
                    {/*                setShowSearchInputModal(true)*/}
                    {/*            }}*/}
                    {/*            >*/}
                    {/*        <i className='fas fa-filter mr-2'/>*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
                <div className='card-body'>
                    <div style={{position: 'relative'}}>
                        {/*<SearchConditionInputModal isShow={showSearchInputModal}*/}
                        {/*                           onSearch={(searchInput) => searchEmployerList(currentPage, orderBy, searchInput)}*/}
                        {/*                           onClose={() => setShowSearchInputModal(false)} />*/}
                        <EmployerListTable employers={employers}
                                           allEmployerIds={allEmployerIds}
                                           totalCount={totalCount}
                                           mode={EmployerListTableMode.EMPLOYER_LIST}
                                           onSearch={(condition) => searchEmployerList(condition)}/>
                        {isLoading &&
                        <div className={'col-sm-12 text-center'}
                             style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                            <div className='spinner-grow text-primary' role='status'>
                                <span className='sr-only'>Loading...</span>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployerList;
